export const ORGANIZATION_FIELD_INDUSTRY = 'industry';
export const ORGANIZATION_FIELD_DESCRIPTION = 'description';
export const ORGANIZATION_FIELD_CITY = 'city';
export const ORGANIZATION_FIELD_STATE = 'state';
export const ORGANIZATION_FIELD_ZIP = 'zip';
